<template>
    <div id="commissionDetailMain">
        <div class="vfpHeader">
            <div class="titleOne">待办公文</div>
            <el-button type="primary" @click="$router.back()">返回</el-button>
        </div>
        <hr>

    <!-- 跳转导航开始 -->
        <div class="AppBar">
            <div v-for="(item,index) in items" :key="index" @click="goto(index)" class="AppBarActive">
                {{ item.tit }}
                <div :class="index==show?item.cl:''"></div>
            </div>
        </div>
        <!-- 项目查看学生 -->
        <projectLookstudnt v-if="this.show==1 && this.$route.query['tid']=='5e21b204-c206-11ed-a4cd-509a4c5b67cf'"></projectLookstudnt>

        <!-- 项目查看创客空间 -->
        <projectLookSpace v-if="this.show==1 && this.$route.query['tid']=='5f7a66d5-c206-11ed-a4cd-509a4c5b67cf'"></projectLookSpace>
        <!-- 项目下载 -->
        <projectDownload v-if="this.show==2"></projectDownload>

        <!-- 项目结项书 -->
        <projectBook v-if="this.show==0"></projectBook>
    </div>
</template>


<script>
import projectBook from './components/projectBook.vue'
import projectDownload from './components/projectDownload.vue'
import projectLookstudnt from './components/projectLookstudnt.vue'
import projectLookSpace from './components/projectLookSpace.vue'
    export default {
        components:{
            projectBook,
            projectDownload,
            projectLookstudnt,
            projectLookSpace
        },
        data() {
            return {
                show:0,
                items:[
                    {tit:'项目申报书',cl:'pr1TitBass'},
                    {tit:'项目查看',cl:'pr1TitBass'},
                    // {tit:'项目下载',cl:'pr1TitBass'},
                ]
            }
        },
        methods:{
            goto(val,aid=''){
                this.show = val
                this.AidShow = aid;
            },
        },
        mounted() {
            console.log(this.$route.query['tid']);
        },
    }
</script>

<style lang="less" scoped> 
#commissionDetailMain{
    display: flex;
    flex-direction: column;
    .downBtn{
        width: 100%;
        display: flex;
        justify-content: center;
    }
}
</style>